import { render } from "./SupplierDetail.vue?vue&type=template&id=c2a921a2"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__